import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const DROPDOWN_PAGE_SIZE = 50;

const fields = {
  _id: '',
  additionCode: '',
  description: '',
  taxDistrict: '',
  section: '',
  townShip: '',
  range: '',
  quarter: '',
};

const additionsGqlQuery = gql`query taxAdditions($criteria: taxAdditionsCriteriaType) {
  taxAdditions(criteria: $criteria) {
    ${fieldsToGqlString(fields)},
  }
}`;

export const TaxAdditions = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    additions: [],
    selectedItems: [],
    hasMore: false,
    currentSkip: 0,
    lastDropdownCriteria: {},
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setAdditions(state, list) {
      state.additions = list;
    },
    appendAdditions(state, list) {
      state.additions = [...state.additions, ...list];
    },
    setHasMore(state, val) {
      state.hasMore = val;
    },
    setCurrentSkip(state, val) {
      state.currentSkip = val;
    },
    setLastDropdownCriteria(state, criteria) {
      state.lastDropdownCriteria = criteria;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadTaxAdditionsRecords({ commit, dispatch }, {
      criteria, baseCrudKey, postProcessTrans, isItSetState,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxAdditions($criteria: taxAdditionsCriteriaType) {
            taxAdditions(criteria: $criteria) {
              ${fieldsToGqlString(fields)},
            }
            }`,
          variables: { criteria: { ...criteria } },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxAdditions } = results.data;
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxAdditions) : taxAdditions;
          if (isItSetState) {
            commit('setAdditions', processedTransData);
            commit('setCurrentSkip', 0);
            commit('setLastDropdownCriteria', criteria || {});
            commit('setHasMore', taxAdditions.length === DROPDOWN_PAGE_SIZE);
          } else {
            commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
          }
          return taxAdditions;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting List.', { root: true });
      }
      return [];
    },
    async loadMoreTaxAdditions({ commit, dispatch, state }, { postProcessTrans }) {
      if (!state.hasMore) return;
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        const newSkip = state.currentSkip + DROPDOWN_PAGE_SIZE;
        const criteria = {
          ...state.lastDropdownCriteria,
          limit: DROPDOWN_PAGE_SIZE,
          skip: newSkip,
        };
        results = await backend.query({
          query: additionsGqlQuery,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxAdditions } = results.data;
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxAdditions) : taxAdditions;
          commit('appendAdditions', processedTransData);
          commit('setCurrentSkip', newSkip);
          commit('setHasMore', taxAdditions.length === DROPDOWN_PAGE_SIZE);
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting more additions.', { root: true });
      }
    },
    async upsertTaxAdditions({ dispatch, commit }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upserttaxAdditionsCodes($item: taxAdditionsInputType!)  {
            upserttaxAdditionsCodes(upsert: $item) {
              statusCode,
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { upserttaxAdditionsCodes } = results.data;
        if (upserttaxAdditionsCodes.statusCode === 200) dispatch('flashSuccess', 'Record updated sussessfully', { root: true });
        else if (upserttaxAdditionsCodes.statusCode === 201) dispatch('flashInfo', 'Different record exits with the entered Addition code, please use a diiferent Addition code', { root: true });
        else dispatch('flashWarn', 'There was a problem in upserting the List', { root: true });
        return upserttaxAdditionsCodes || {};
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the List', { root: true });
      }
      return {};
    },
    async deleteTaxAddition({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deletetaxAddition ($id: ID!)  {
            deletetaxAddition(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deletetaxAddition._id;
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = taxData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the List', { root: true });
      }
    },
  },
};

export default TaxAdditions;
